import { render, staticRenderFns } from "./car-location-phones.vue?vue&type=template&id=530bd37a&"
import script from "./car-location-phones.vue?vue&type=script&lang=js&"
export * from "./car-location-phones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports